<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <div class="search-text">
            <h2>轻便研究 产业导航</h2>
          </div>
          <el-input placeholder="请输入检索词"
                    v-model="searchInput"
                    class="search-input"
                    @keyup.enter.native="handleSearch">
            <!-- <el-select
              class="search-input_select"
              v-model="searchSelect"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="全部" :value="-1"></el-option>
              <el-option
                v-for="(item, index) in firstIndustryList"
                :key="index"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select> -->
            <el-button class="search-input_button"
                       slot="append"
                       @click="handleSearch">检索</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div id="body">
      <div class="wrapper">
        <div :class="
            searchFilterShow ? 'search-filter filter-show' : 'search-filter'">
          <div class="filter-op"
               @click="searchFilterShow = !searchFilterShow">检索筛选 <i class="el-icon-arrow-up"></i></div>
          <el-form label-width="8.0em">
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-class.png"
                     alt="" />行业分类
              </div>
              <el-checkbox-group v-model="filterIndustry"
                                 @change="filterIndustryChange">
                <el-checkbox v-for="(item, index) in firstIndustryList"
                             :key="index"
                             :label="item.id">
                  {{ item.title }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <section>
        <div class="ibox">
          <div class="ibox_content">
            <div class="guid-tabs_content show-more">
              <div class="guid-content">
                <div class="guid-class-list">
                  <el-skeleton :loading="loading"
                               :count="20"
                               animated>
                    <template slot="template">
                      <dl>
                        <dt class="name">
                          <el-skeleton-item variant="h2"
                                            style="width: 50%" />
                          <el-skeleton-item variant="h2"
                                            style="width: 70px; margin-left: 15px;" />
                        </dt>
                        <dd class="intro">
                          <el-skeleton-item variant="text" />
                          <el-skeleton-item variant="text" />
                          <el-skeleton-item variant="text"
                                            style="width:40%; " />
                        </dd>

                      </dl>
                    </template>
                    <template>
                      <dl v-for="(industry, index) in records"
                          :key="index"
                          @click="$router.push('/industry/detail?id=' + industry.id)">
                        <dt class="name">
                          <router-link :to="'/industry/detail?id=' + industry.id">
                            {{ industry.title }}
                          </router-link>
                          <span class="status s-new">
                            {{ industry.parentTitle }}
                          </span>
                          <!-- <span class="status s-new">报告上新</span> -->
                        </dt>
                        <dd class="intro"
                            :title="industry.remark">
                          {{ cutstring(industry.remark, 79) }}
                        </dd>
                      </dl>
                    </template>
                  </el-skeleton>

                </div>
                <div class="search-bottom">
                  <div class="search-page-total">
                    共 {{ total > 10000 ? "10000+" : total }} 条 第
                    {{ pageIndex }}/{{
                      pageCount > 1000 ? "1000+" : pageCount
                    }}页
                  </div>
                  <div class="search-page">
                    <el-pagination :current-page="pageIndex"
                                   :page-size="pageSize"
                                   layout=" prev,pager,next,jumper"
                                   :total="total"
                                   @current-change="handleCurrentPageChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import { cutstr } from "../../util/utils";

export default {
  data () {
    return {
      searchFilterShow: false,
      firstIndustryList: [],
      searchSelect: -1,
      searchInput: "",
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      pageCount: 0,
      records: [],
      loading: false,
      filterIndustry: [],
    };
  },
  created () {
    this.getIndustryList(0).then((data) => {
      if (data && data.length > 0) {
        this.firstIndustryList = data;
      }
    });
    this.handleSearch();
  },
  mounted () { },
  methods: {
    filterIndustryChange () {
      this.getPagedList(true);
    },
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      this.getPagedList(false);
    },
    handleSearch () {
      // if (!this.searchInput) {
      //   this.$message.warning("请输入检索词");
      // }
      this.getPagedList(true);
    },
    getPagedList (resetPageIndex) {
      if (resetPageIndex) {
        this.pageIndex = 1;
      }

      this.loading = true;
      axiosRequest(
        "/industry/paged-list",
        {
          title: this.searchInput,
          //parentId: this.searchSelect,
          parentId: this.filterIndustry,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.code === 200) {
            this.records = res.data.data.records;
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cutstring (str, len) {
      return cutstr(str, len);
    },
    dateFormat (cellValue) {
      if (!cellValue) return "";
      // return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return moment(cellValue).format("YYYY-MM-DD");
    },
    async getIndustryList (parentId) {
      let data;

      await axiosRequest(
        "/industry/index-list",
        { parentId: parentId },
        axiosOptions("post", "", "json")
      ).then((res) => {
        data = res.data.data;
      });

      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";
@import "@/assets/css/web.scss";

.guid-tabs {
  &_content {
    max-height: inherit;
    min-height: inherit;
    padding: 20px 0;
    &:after {
      display: none;
    }
  }
}
.guid-content {
  max-height: inherit;
  min-height: inherit;
  .guid-class-list {
    width: 100%;
    height: auto;
    margin-left: 0;
    .guid-info {
      position: relative;
      left: 0;
      top: 0;
      float: left;
      width: 25%;
      height: 342px;
    }
    dl {
      position: relative;
      width: calc(100% / 4);
      vertical-align: top;
    }
  }

  .search-bottom {
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 14px;
    @media screen and (max-width: 768px) {
      padding: 0 15px;
    }
    ::v-deep .el-pagination {
      .el-pagination__total:before {
        background-color: #c9e4ed;
      }
      .el-pager li {
        display: inline-block;
      }
      .el-pager li.active {
        margin-left: 5px !important;
      }
    }
  }
}
</style>
